/**
 * 根据用户id获取用户头像URL
 *
 * @param userId - 用户ID
 * @returns 用户头像URL
 * - 如果userId为空，返回默认头像
 * - 如果userId有效，返回对应的用户头像URL
 *
 * @example
 * ```ts
 * getUserAvatar('');  // => 'https://u.thsi.cn/avatar/default/12_108_108.png'
 * getUserAvatar('123456');  // => 'https://u.thsi.cn/avatar/6456/123456.gif'
 * ```
 */
export function getUserAvatar(userId: string | number): string {
  // 默认头像URL
  const DEFAULT_AVATAR = "https://u.thsi.cn/avatar/default/12_108_108.png";

  // 参数校验
  if (!userId) {
    return DEFAULT_AVATAR;
  }

  // 常量配置
  const SLICE_LENGTH = -4;
  const BASE_URL = "https://u.thsi.cn/avatar";

  // 获取userId的后4位作为目录名
  const dirName = String(userId).slice(SLICE_LENGTH);

  // 返回完整的头像URL
  return `${BASE_URL}/${dirName}/${userId}.gif`;
}
